export default function pageFaute()
{
    return <div className="centre"><div >Désolé, nous avons rencontré un problème.</div>
    <div><a href="https://concours.evalquiz.com">Retour à l'accueil</a></div>
    </div>
} 